import React from 'react';
import { styled } from 'styled-components';
import Frown from './Icons/Frown.js';
import Meh from './Icons/Meh.js';
import Smile from './Icons/Smile.js';
const CaseSatisfaction = (props) => {
    const s = props.satisfaction;
    return (React.createElement(Satisfaction, null,
        React.createElement(SatisfactionIcon, null,
            s.satisfaction === 1 && React.createElement(Frown, null),
            s.satisfaction === 3 && React.createElement(Meh, null),
            s.satisfaction === 5 && React.createElement(Smile, null)),
        React.createElement(Comment, null, s.comment != null ? s.comment : 'Ingen kommentar')));
};
export default CaseSatisfaction;
const SatisfactionIcon = styled.div `
  margin-right: 10px;
  background-color: lightgrey;
  display: inline-block;
  padding: 5px 5px 2px 5px;
  border-radius: 3px;
`;
const Satisfaction = styled.div `
  display: flex;
`;
const Comment = styled.p `
  margin: 0;
`;
//# sourceMappingURL=CaseSatisfaction.js.map